"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimesEnum = void 0;
var TimesEnum;
(function (TimesEnum) {
    TimesEnum[TimesEnum["SECS_IN_ONE_MIN"] = 60] = "SECS_IN_ONE_MIN";
    TimesEnum[TimesEnum["MIN_IN_ONE_HOUR"] = 60] = "MIN_IN_ONE_HOUR";
    TimesEnum[TimesEnum["DAYS_IN_WEEK"] = 7] = "DAYS_IN_WEEK";
    TimesEnum[TimesEnum["DAYS_IN_MONTH"] = 30] = "DAYS_IN_MONTH";
    TimesEnum[TimesEnum["DAYS_IN_THREE_MONTHS"] = 90] = "DAYS_IN_THREE_MONTHS";
    TimesEnum[TimesEnum["DAYS_IN_HALF_YEAR"] = 180] = "DAYS_IN_HALF_YEAR";
    TimesEnum[TimesEnum["DAYS_IN_YEAR"] = 365] = "DAYS_IN_YEAR";
    TimesEnum[TimesEnum["DAYS_IN_TWO_YEARS"] = 730] = "DAYS_IN_TWO_YEARS";
    TimesEnum[TimesEnum["MILLI_SECS_IN_ONE_SEC"] = 1000] = "MILLI_SECS_IN_ONE_SEC";
    TimesEnum[TimesEnum["SECS_IN_ONE_HOUR"] = 3600] = "SECS_IN_ONE_HOUR";
    TimesEnum[TimesEnum["MILLI_SECS_IN_ONE_MINUTE"] = 60000] = "MILLI_SECS_IN_ONE_MINUTE";
    TimesEnum[TimesEnum["MILLI_SECS_IN_TWO_MINUTES"] = 120000] = "MILLI_SECS_IN_TWO_MINUTES";
    TimesEnum[TimesEnum["MILLI_SECS_IN_ONE_HOUR"] = 3600000] = "MILLI_SECS_IN_ONE_HOUR";
})(TimesEnum = exports.TimesEnum || (exports.TimesEnum = {}));
//# sourceMappingURL=times.enum.js.map